import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <hr />
      <div className="footer-content">
        <p
          className="company-name"
          style={{ fontSize: ".75rem", marginTop: "5px" }}
        >
          <a
            style={{
              textDecoration: "none",
            }}
            href="/tnc"
          >
            Terms & Condition & Refund
          </a>{" "}
          |{" "}
          <a
            style={{
              textDecoration: "none",
            }}
            href="/privacy"
          >
            Privacy Policy
          </a>
        </p>
        <p className="company-name">PT Sahabat Olah Duit</p>
        <p className="address">
          Rawapapan Residence, Jl. H. Leman No.139 A, Bintaro, Pesanggrahan,
          Jakarta Selatan, Jakarta 12330
        </p>
        <p className="rights">© 2025 SODTix.com. All Rights Reserved.</p>
        <a href="mailto:hello@sodtix.com">hello@sodtix.com</a>
      </div>
    </footer>
  );
};

export default Footer;
